import { useState, useCallback } from 'react';
import { incidentFormSchema } from './incidentSchema';

export function useIncidentForm(initialData = {}) {
  const [formData, setFormData] = useState({
    name: initialData.name || '',
    email: initialData.email || '',
    system: '',
    priority: '',
    impact: '',
    category: '',
    issueType: '',
    subject: '',
    comments: '',
    ...initialData
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateField = useCallback((fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear error for this field when user starts typing
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  }, [errors]);

  const validateForm = () => {
    try {
      incidentFormSchema.parse(formData);
      setErrors({});
      return true;
    } catch (error) {
      if (error) {
        const newErrors = {};
        error.issues.forEach(err => {
          const path = err.path.join('.');
          newErrors[path] = err.message;
        });
        
        // Handle the custom validation for subject + category length
        const subjectWithCategory = `${formData.category}: ${formData.subject}`;
        if (subjectWithCategory.length > 50) {
          const overLength = subjectWithCategory.length - 50;
          newErrors.subject = overLength === 1 
            ? "Short Description Including Category is too long by 1 character"
            : `Short Description Including Category is too long by ${overLength} characters`;
        }
        
        setErrors(newErrors);
      }
      return false;
    }
  };

  const resetForm = useCallback((resetData = {}) => {
    setFormData({
      name: resetData.name || '',
      email: resetData.email || '',
      system: '',
      priority: '',
      impact: '',
      category: '',
      issueType: '',
      subject: '',
      comments: '',
    });
    setErrors({});
    setIsSubmitting(false);
  }, []);

  const clearErrors = useCallback(() => {
    setErrors({});
  }, []);

  return {
    formData,
    errors,
    isSubmitting,
    setIsSubmitting,
    updateField,
    validateForm,
    resetForm,
    clearErrors
  };
}
